<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" >
<!--                <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                    <el-tab-pane label="分类" name="1"></el-tab-pane>
                    <el-tab-pane label="标签" name="2"></el-tab-pane>
                    <el-tab-pane label="模块" name="3"></el-tab-pane>
                </el-tabs>-->
                <el-radio-group v-model="activeName">
                    <el-radio-button label="1">分类</el-radio-button>
                    <el-radio-button label="2">标签</el-radio-button>
                    <el-radio-button label="3">模块</el-radio-button>
                </el-radio-group>
            </el-form>
            <el-button type="primary" @click="edit({})">新增</el-button>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    type="index"
                    width="50">
                </el-table-column>
                <el-table-column
                    min-width="180"
                    label="名称" >
                    <template slot-scope="scope">
                        <div v-if="scope.row.type != 3 ">{{scope.row.name}}</div>
                        <div v-if="scope.row.type == 3 ">{{scope.row.fromInstitutionId == 1  ? scope.row.platformModuleTitle : scope.row.name}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="180"
                    label="顺序调整" >
                    <template slot-scope="scope">
                        <i class="el-icon-arrow-up font20 order_btn" @click="up(scope.row, scope.$index)"></i>
                        <i class="el-icon-arrow-down font20 order_btn" @click="down(scope.row, scope.$index)"></i>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="180"
                >
                    <template slot-scope="scope" v-if="scope.row.institutionId != 1">
                        <el-popconfirm @onConfirm="del(scope.row)"
                                       title="确认移除该配置吗？" >
                            <el-link type="danger" slot="reference"
                                     :underline="false" ><i class="iconfont icon-shanchu"></i><b>移除</b></el-link>
                        </el-popconfirm>

                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
        <EditDraw v-if="showEdit" @submit="loadData"
                  @close="showEdit=false" :item="type"></EditDraw>
    </div>
</template>

<style scoped>
    .order_btn {
        display: inline-block;
        background: var(--primary);
        color: white;
        margin: 0 5px;
        cursor: pointer;
        padding: 2px;
    }
</style>
<style>

</style>

<script>

    import {mapMutations} from 'vuex';
    import EditDraw from './TrainConfigEdit';
    export default {
        components: {
            EditDraw
        },
        props: [
            "attr"
        ],
        data() {
            return {
                activeName:'1',
                tableData: [],
                type: 0,
                showEdit: false,
                form:{type:1},
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                types:[],
            }

        },
        watch: {
            "activeName":{
                handler: function (newValue) {
                    this.form.type = this.activeName;
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true
            }
        },

        methods: {
            ...mapMutations(["openTab"]),
            handleClick(tab, event) {
                this.changeType(tab.name);
            },
            edit(item) {
                this.type = this.form.type;
                this.showEdit = true;
            },
            del(item) {
                this.$ajaxGet("/trainConfig/del/" + item.id, (data) => {
                    this.loadData();
                })
            },
            changeType(type) {
                this.form.type = type;
                this.loadData();
            },
            loadData() {
                if(this.form.type == 3){
                    this.$ajaxPost("/trainConfig/listModuleByPager", {
                        //schoolType: this.schoolType,
                        pager: {...this.pager, dataTotal: 0}
                    }, (data) => {
                        //分页不能带offset，否则会影响后台计算最新offset
                        let {offset, ...pager} = data.pager;
                        this.pager = pager;
                        this.tableData = data.result;
                        this.showEdit = false;
                    })
                    return ;
                }else{
                    this.$ajaxPost("/trainConfig/list", {
                        form: this.form,
                        pager: {...this.pager, dataTotal: 0}
                    }, (data) => {
                        //分页不能带offset，否则会影响后台计算最新offset
                        let {offset, ...pager} = data.pager;
                        this.pager = pager;
                        this.tableData = data.result;
                        this.showEdit = false;
                    })
                }
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
            up(item, index) {

                if (index == 0) {
                    return;
                } else {

                    let prevItem = this.tableData[index-1];
                    console.log(this.tableData[index])
                    console.log(this.tableData[index-1]);
                    this.$ajaxGet(`/trainConfig/updateRank/${item.id}-${item.rank}-${prevItem.rank}`, data=> {
                        this.loadData();
                    } )
                }
            },
            down(item, index) {
                if (index == this.tableData.length - 1) {
                    return;
                } else {
                    let afterItem = this.tableData[index+1];
                    this.$ajaxGet(`/trainConfig/updateRank/${item.id}-${item.rank}-${afterItem.rank}`, data=> {
                        this.loadData();
                    } )
                }
            },
            loadType() {
                this.$ajaxGet("/trainConfig/listOption", (data) => {
                     this.types = data.result;
                })
            },
            preview(item) {
            }
        },

        created() {
            this.loadData();
            this.loadType();
        }

    }
</script>
